import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import enTranslations from "./locales/en";
import frTranslations from "./locales/fr";
import esTranslations from "./locales/es";
import itTranslations from "./locales/it";

// Configure i18n but don't initialize yet (will be done client-side)
const i18nConfig = {
  debug: false,
  fallbackLng: "fr", // Default to French as the app is primarily in French
  interpolation: {
    escapeValue: false, // React already protects from XSS
  },
  resources: {
    en: {
      translation: enTranslations,
    },
    fr: {
      translation: frTranslations,
    },
    es: {
      translation: esTranslations,
    },
    it: {
      translation: itTranslations,
    },
  },
  detection: {
    // Order of detection methods. `navigator` is deliberately OMITTED: the app is
    // primarily French, so a non-French browser must NOT silently switch the UI to
    // English. Only an explicit user choice (persisted to localStorage via the
    // LanguageSelector) overrides the French default; otherwise htmlTag (`<html
    // lang="fr">`) / fallbackLng keep it French.
    order: ["localStorage", "htmlTag"],
    // Cache the language selection
    caches: ["localStorage"],
    lookupLocalStorage: "i18nextLng",
  },
};

// On the client, use LanguageDetector to pick up localStorage/navigator preference.
// On the server (SSR), initialize with defaults only (fallbackLng: "fr").
if (typeof window !== "undefined") {
  i18n.use(LanguageDetector).use(initReactI18next).init(i18nConfig);
} else {
  i18n.use(initReactI18next).init(i18nConfig);
}

export default i18n;
